import type { FaireThemeEntity } from "../../entity_types/theme";

export const crystal_sanctuary_and_healing: FaireThemeEntity = {
  token: "crystal-sanctuary-and-healing",
  type: "theme",
  name: "Crystal Sanctuary & Healing",
  description: "Curated natural stones to support your patrons' spiritual journeys, from calming Blue Chalcedony to heart-centered Rose Quartz. Perfect for your specialized Vedic and shamanic offerings.",
  teaser: "This theme aligns with Shiva's Gift Shop's core identity, as they specifically list crystals, crystal healing, and Vedic and Shamanic practices in their business description and product quality signals.",
  detail: "The additional_context shows that four out of the five most recently ordered items are spiritual stones from The Crystal Tabby, including Rose Quartz points and Blue Chalcedony hearts.",
  bgColor: "#FDE8D0",
  tileBgColor: "#8b5e3c",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_er2m9n5gwr",
    "p_fqggnmpyca",
    "p_dkchqu54rp",
    "p_wadws4e9b9",
    "p_zq4skfzn5h",
    "p_n4qkmcwx8a",
    "p_j9acugrfc8",
    "p_s3ke2vfab6",
    "p_k8z4x554qm",
    "p_vmp8hdrknp",
    "p_thdj3sssvq",
    "p_fe69e9w5bd",
    "p_mc6ysyjy8c",
    "p_u6vs98559h",
    "p_j4aejz9qde",
    "p_7cejnmeejd",
    "p_2av5wz3x5c",
    "p_qvasuqk42v",
    "p_jw7agsw4dh",
    "p_7rpbegajur",
    "p_bjmyvaczc8",
    "p_mea7tnxym6",
    "p_6yfn8y25ax",
    "p_bhbw3ppzm9",
    "p_y9ypg6zg8a",
    "p_bpdyamc9mg",
    "p_7btqth67y7",
    "p_6yeemfcaq8",
    "p_bcgzfthk5t",
    "p_jr9k6mkpqh",
    "p_tnsphxruwm",
    "p_4yzdyctk4k",
    "p_aa7ex4avg2",
    "p_qdjefzv8vk",
    "p_mzzckmkk2m",
    "p_9223nde5um",
    "p_g5at7my5x5",
    "p_r3zvv8xbeu",
    "p_jnzc35q5hs",
    "p_2zc3faxr49",
    "p_5247tewrpq",
    "p_7pm7ysksec",
    "p_yjhr46jqeb",
    "p_5e8pynduyx",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
